import { extendObservable } from 'mobx';
import { PecaDto } from '../dto/PecaDto';
import { TipoDocumentoProcessoDto } from '../dto/TipoDocumentoProcessoDto';
import { ObjectUtils } from './../../utils/ObjectUtils';
import { TipoPeca } from './TipoPeca';
export class Peca implements PecaDto {
    tipo: TipoDocumentoProcessoDto;
    criadoEm: string;
    origem: string;
    static mobxInicial = () => ({
        codigoPeticaoStatus: undefined,
        descricaoPeticaoStatus: undefined,
        peticaoNaoLida: undefined
    });

    static novo(partial: Partial<Peca>): Peca {
        const peca = new Peca();
        extendObservable(peca, Peca.mobxInicial());

        peca.codigoPeticaoStatus = partial.codigoPeticaoStatus;
        peca.descricaoPeticaoStatus = partial.descricaoPeticaoStatus;
        peca.peticaoNaoLida = partial.peticaoNaoLida;
        const pecaFinal = ObjectUtils.assign(peca, partial);

        return pecaFinal;
    }
    assuntoPeticao?: string = undefined;
    numSeqPeca?: number = undefined;
    numPeticao?: number = undefined;
    idProcesso: number = undefined;
    id: number = undefined;
    idUnicoDocumento: string = undefined;
    juntadoEm: Date = undefined;
    tipoPeca: TipoPeca = undefined;
    criador: string = undefined;
    titulo: string = undefined;
    assinado: boolean = undefined;
    tipoArquivo: string = undefined;
    possuiCertidao: boolean = undefined;
    numeroOrdem: number = undefined;
    peticaoNaoLida: boolean = undefined;
    ativo: boolean = undefined;
    principal: boolean = undefined;
    codigoPeticaoStatus: number;
    descricaoPeticaoStatus: string = undefined;
    apreciado: boolean;

    urlDocumentoHTML: string;
    pecaDespachoAdmissibilidade?: boolean = undefined;
    numeroProcesso?: string = undefined;

}
